export const showSuccess = (msg) => {
    toast.show(msg);
};

export const showToast = (msg) => {
    toast.show(msg);
};
